module.exports = __webpack_public_path__ + "img/-LV57tG4qQpP-FQoyMI6.f7489f38.jpg";